import { render, staticRenderFns } from "./SLSectionStrategy.vue?vue&type=template&id=0fedd676&scoped=true&"
import script from "./SLSectionStrategy.vue?vue&type=script&lang=js&"
export * from "./SLSectionStrategy.vue?vue&type=script&lang=js&"
import style0 from "./SLSectionStrategy.vue?vue&type=style&index=0&id=0fedd676&lang=scss&scoped=true&"
import style1 from "./SLSectionStrategy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fedd676",
  null
  
)

export default component.exports